import ForgotPasswordPage from "@/features/auth/pages/forgot-password";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(auth)/__auth/forgot-password")({
  component: AuthRoute,
});

function AuthRoute() {
  return <ForgotPasswordPage />;
}
